class Header {
    constructor() {
        this.side = document.querySelector('.header__side')
        this.burger = document.querySelector('.header__burger-icon')
        this.close = document.querySelector('.header__close')
        this.init();
    }

    init() {
        this.openHandle();
        this.closeHandle();
    }

    openHandle() {
        this.burger && this.burger.addEventListener('click', (event) => {
            this.side && this.side.classList.add('active')
        })
    }

    closeHandle() {
        this.close && this.close.addEventListener('click', (event) => {
            this.side && this.side.classList.remove('active')
        })
    }
}

new Header();
